/* eslint-disable no-plusplus */
/* eslint-disable no-unused-vars */
// eslint-disable-next-line import/no-unresolved
const baseProductBase = require('base/product/base');
const baseUtils = require('./baseUtils');
const baseDetail = require('./baseDetail');
const baseGrid = require('./baseGrid');
const constants = require('../constants');

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    if ($('.product-detail').hasClass('product-wrapper')) {
        baseDetail.getQuantitySelected($el);
    }

    baseGrid.getQuantitySelected($el);
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
baseProductBase.getQuantitySelected = $el => getQuantitySelector($el).val();

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, $productContainer) {
    if ($('#quickViewModal').hasClass('show')) {
        baseProductBase.attributeSelect(selectedValueUrl, $productContainer);
    }
    if ($('.product-detail').length) {
        baseDetail.attributeSelect(selectedValueUrl, $productContainer);
        // added the attributeSelect for grids because can be included carousels in PDP
        baseGrid.attributeSelect(selectedValueUrl, $productContainer);
    } else {
        baseGrid.attributeSelect(selectedValueUrl, $productContainer);
    }
}

const colorAttribute = () => {
    // eslint-disable-next-line func-names
    $(document.body).on('click', 'a.swatchable', (e) => {
        e.preventDefault();
        const target = $(e.currentTarget);

        if (target.attr('disabled')) {
            return;
        }

        let $productContainer = target.closest('.set-item');
        if (!$productContainer.length) {
            $productContainer = target.closest('.product-detail');
        }
        // It has one color the element will be always checked
        const attribute = target.closest('.attribute');

        const disable = attribute.find('span').length === 1
            || !target
                .find('span')
                .hasClass('selected');

        const attr = target
            .closest('.attribute')
            .data('attr');

        let url = target.attr('href');
        const page = $('.page').data('action');
        url += `&isgrid=${(page !== 'Product-Show')}`;

        if ($productContainer.hasClass('product-wrapper')) {
            baseDetail.attributeSelect(url, $productContainer);
            baseDetail.checkAddToCartButton($productContainer, disable, attr);
        } else {
            baseGrid.attributeSelect(url, $productContainer);
            baseGrid.checkAddToCartButton($productContainer, disable, attr);
        }
    });
};

const changeHandler = (select) => {
    const selectedOption = select.find('option:selected').length > 1 ? 1 : 0;
    const activeOption = select.find('option:selected').eq(selectedOption).attr('value');
    let $productContainer = select.closest('.set-item');
    if (!$productContainer.length) {
        $productContainer = select.closest('.product-detail');
    }
    const searchOpen = select.parents('.suggestions').length > 0;
    const page = $('.page').data('action');
    const compare = page !== 'Product-Show' ? true : searchOpen;
    const url = `${activeOption}&isgrid=${compare}`;
    const attr = select
        .closest('.attribute')
        .data('attr');
    const disable = select
        .find('option:selected')
        .eq(selectedOption)
        .attr('data-attr-value') !== undefined;

    if ($productContainer.hasClass('product-wrapper')) {
        baseDetail.attributeSelect(url, $productContainer);
        baseDetail.checkAddToCartButton($productContainer, disable, attr);
    } else {
        baseGrid.attributeSelect(url, $productContainer);
        baseGrid.checkAddToCartButton($productContainer, disable, attr);
    }
};

const selectAttribute = () => {
    const docBody = $(document.body);
    docBody.on('change', 'select[class*="select-"], .options-select', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const thisTarget = $(e.currentTarget);
        changeHandler(thisTarget);
    });

    docBody.on('click', '.attribute-wrapper .attributeLink', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const thisTarget = $(e.currentTarget);
        const sizeOptionDataValue = thisTarget.data('attr-value');
        const currentActiveOption = thisTarget.parents('.attribute-wrapper').find('.attributeLink.selected').data('attr-value');
        const isProductSet = $('.set-items').length;

        const attributesWrapper = $('.attribute-pdp');
        const currentTargetWrapper = thisTarget.parents('.attribute-pdp');

        attributesWrapper.removeClass('active');
        currentTargetWrapper.addClass('active');

        if (sizeOptionDataValue !== currentActiveOption && !thisTarget.hasClass('swatchable')) {
            const sizeDropdown = thisTarget.siblings('select');
            const sizeLinks = thisTarget.parent().find('.attributeLink').not(thisTarget);

            sizeDropdown.find('option').attr('selected', false);
            sizeDropdown.find(`option[data-attr-value="${sizeOptionDataValue}"]`).attr('selected', true);

            sizeLinks.removeClass('selected');
            changeHandler(sizeDropdown);
            thisTarget.addClass('selected');
        }

        if (thisTarget.parents('.ctabar-attributes-wrapper').length) {
            thisTarget.parents('.attribute-wrapper').find('.attribute-selected').trigger('click');
        }

        if (thisTarget.hasClass('icon-email-line')) {
            const outOfStockButton = isProductSet
                ? thisTarget.parents('.set-item').find('.outofstock-button') : $('.outofstock-button');
            outOfStockButton.trigger('click');
        }

        if (window.innerWidth < constants.viewport_bootstrap.xls) {
            $('html').css('overflow', 'visible');
            $('.attribute-overlay').fadeOut();
        }
    });

    baseDetail.checkSelectedOption();
};

const printModalBonusProductData = (target, choiceOfBonusProduct, totalQty, submittedQty) => {
    const pid = target.data('pid');
    const optionID = choiceOfBonusProduct.find('.product-option').data('option-id');
    const valueId = choiceOfBonusProduct.find('.options-select option:selected').data('valueId');

    // eslint-disable-next-line prefer-template
    const selectedBonusProductHtml = ''
                    + '<div class="selected-pid mr-lg-3" '
                    + 'data-pid="' + pid + '"'
                    + 'data-qty="' + submittedQty + '"'
                    + 'data-optionID="' + (optionID || '') + '"'
                    + 'data-option-selected-value="' + (valueId || '') + '"'
                    + '>'
                    + '<div class="bonus-product-name" >'
                    + choiceOfBonusProduct.find('.img-bonus-product').html()
                    + '</div>'
                    + '<i class="icon-cross-line" aria-hidden="true"></i>'
                    + '</div>';

    $('#chooseBonusProductModal .selected-bonus-products').append(selectedBonusProductHtml);
    $('.pre-cart-products').html(totalQty);
    $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
    $('.add-bonus-products').addClass('selected');
    target.addClass('selected');
};

const selectBonusProduct = () => {
    const docBody = $(document.body);

    // eslint-disable-next-line func-names
    $(document).on('click', '.product-detail', (e) => {
        e.stopImmediatePropagation();
        if (!$(e.currentTarget).hasClass('disabled')) {
            const target = $(e.currentTarget);
            const choiceOfBonusProduct = target.parents('.choice-of-bonus-product');
            const maxPids = $('.choose-bonus-product-dialog').data('total-qty');
            const submittedQty = parseInt(choiceOfBonusProduct.find('.bonus-quantity-select').val(), 10);
            const selectedButton = choiceOfBonusProduct.find('.select-bonus-product');
            let totalQty = 0;

            $('.select-bonus-product').not(selectedButton).removeClass('selected');
            selectedButton.addClass('selected');

            // eslint-disable-next-line func-names
            $.each($('#chooseBonusProductModal .selected-bonus-products .selected-pid'), (_indx, elm) => {
                totalQty += $(elm).data('qty');
            });
            totalQty += submittedQty;

            if (totalQty <= maxPids) {
                printModalBonusProductData(target, choiceOfBonusProduct, totalQty, submittedQty);
            } else if (totalQty > maxPids && maxPids === 1) {
                $('#chooseBonusProductModal .selected-bonus-products > .selected-pid').remove();
                printModalBonusProductData(target, choiceOfBonusProduct, maxPids, submittedQty);
            } else {
                $('.selected-bonus-products .bonus-summary').addClass('alert-danger');
            }
        }
    });

    docBody.on('click', '.cart-page .bonus-product-button-custom', (e) => {
        e.stopPropagation();
        $.spinner().start();
        const thisTarget = $(e.currentTarget);
        thisTarget.addClass('launched-modal');
        $.ajax({
            url: thisTarget.data('url'),
            method: 'GET',
            dataType: 'json',
            success: (data) => {
                baseUtils.chooseBonusProducts(data);
                $.spinner().stop();
            },
            error: () => {
                $.spinner().stop();
            },
        });
    });
};

module.exports = {
    attributeSelect,
    methods: baseProductBase.methods,

    focusChooseBonusProductModal: baseProductBase.focusChooseBonusProductModal,
    onClosingChooseBonusProductModal: baseProductBase.onClosingChooseBonusProductModal,
    trapChooseBonusProductModalFocus: baseProductBase.trapChooseBonusProductModalFocus,
    colorAttribute,
    selectAttribute,
    availability: baseDetail.availability,
    descriptionBlock: baseDetail.descriptionBlock,
    addToCart: baseDetail.addToCart,
    selectBonusProduct,
    removeBonusProduct: baseProductBase.removeBonusProduct,
    enableBonusProductSelection: baseProductBase.enableBonusProductSelection,
    showMoreBonusProducts: baseProductBase.showMoreBonusProducts,
    addBonusProductsToCart: baseProductBase.addBonusProductsToCart,
    getPidValue: baseDetail.getPidValue,
    getQuantitySelected: baseProductBase.getQuantitySelected,
    miniCartReportingUrl: baseProductBase.miniCartReportingUrl,
    addToCartGrid: baseGrid.addToCartGrid,
    disableButtonCartGrid: baseGrid.disabledButtonCartGrid,
    handlePostCartAdd: baseUtils.methods.handlePostCartAdd,
    imageZoom: baseDetail.imageZoom,
};
